import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { BUSINESS, CASUAL } from 'reporting-data/constants/aiSettings';
import { getAIInsightsSummaryTone } from 'reporting-data/report/reportGetters';
import { setAIInsightsSummaryTone } from 'reporting-data/report/reportSetters';
import { useAIInsightsTracker } from '../useAIInsightsTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT = 'DEFAULT';
const actions = {
  [CASUAL]: 'toneCasual',
  [BUSINESS]: 'toneBusiness',
  [DEFAULT]: 'toneDefault'
};
export function AISettingsSummaryTone({
  previewReport,
  onPreviewReportChange
}) {
  const tone = getAIInsightsSummaryTone(previewReport);
  const {
    trackAIInsightsEvent
  } = useAIInsightsTracker(previewReport);
  function onToneChange({
    target: {
      value
    }
  }) {
    trackAIInsightsEvent({
      action: actions[value]
    });
    const newTone = value === DEFAULT ? undefined : value;
    const updatedReport = setAIInsightsSummaryTone(previewReport, newTone);
    onPreviewReportChange(updatedReport);
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: I18n.text('reporting-enablement.aiInsightsSettings.tone.title'),
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "ai-insights-summary-tone",
      children: [/*#__PURE__*/_jsx(RadioInput, {
        value: DEFAULT,
        checked: !tone,
        onChange: onToneChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.aiInsightsSettings.default"
        })
      }), /*#__PURE__*/_jsx(RadioInput, {
        value: CASUAL,
        checked: tone === CASUAL,
        onChange: onToneChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.aiInsightsSettings.tone.casual"
        })
      }), /*#__PURE__*/_jsx(RadioInput, {
        value: BUSINESS,
        checked: tone === BUSINESS,
        onChange: onToneChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.aiInsightsSettings.tone.business"
        })
      })]
    })
  });
}